import React from "react";
import { MdSmartToy } from "react-icons/md";
import useAiStatus from "../../hooks/useAiStatus";

const AiStatusCard = ({ waitingCount = 0, className = "" }) => {
  const { aiConfigured: isOnline } = useAiStatus();

  return (
    <div
      className={`flex items-center gap-3 rounded-2xl border border-farmazon-border bg-farmazon-surface p-2 shadow-sm ${className}`}
    >
      <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border-2 border-farmazon-purple-border bg-farmazon-purple-soft">
        <MdSmartToy className="h-4 w-4 text-farmazon-purple-text" />
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <span className="text-[16px] font-extrabold text-farmazon-text">IA – Márcia</span>
          {isOnline ? (
            <span className="rounded-md bg-farmazon-green-soft px-2 py-0.5 text-[10px] font-bold text-green-700">
              Online
            </span>
          ) : (
            <span className="rounded-md bg-farmazon-red-soft px-2 py-0.5 text-[10px] font-bold text-red-600">
              Offline
            </span>
          )}
        </div>
        <div className="mt-0.5 text-xs text-farmazon-text-muted">
          Atendendo {waitingCount} conversas
        </div>
      </div>

      <svg viewBox="0 0 60 30" className="h-7 w-[60px] flex-shrink-0 text-farmazon-purple-text">
        <polyline
          points="0,22 8,18 14,24 22,8 30,20 38,5 46,16 54,12 60,18"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default AiStatusCard;
